export default "__VITE_ASSET__53d52992__"